import React, { useState, useEffect, useRef } from "react";
import { TbEdit } from "react-icons/tb";
import { MdDeleteOutline } from "react-icons/md";
import DeleteModal from "./Assets/DeleteModal";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const Category = ({ isSidebarCollapsed }) => {
  const fileInputRef = useRef(null);
  const [categories, setCategories] = useState([]);
  const [formData, setFormData] = useState({ title: "", description: "" });
  const [editId, setEditId] = useState(null);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [preview, setPreview] = useState("https://cdn-icons-png.flaticon.com/512/10446/10446694.png");
  const [file, setFile] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch("https://backend.soapplants.com/api/v1/industrial-solutions/view", {
        method: "GET",
         headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${localStorage.getItem("authToken")}`,
          },
      });
        if (response.status === 401) {
        toast.error("Session expired, please log in again");
        localStorage.removeItem("authToken");
        navigate('/login');
        return;
      }
      const result = await response.json();
      if (result.success) setCategories(result.data);
      else toast.error(result.message || "Failed to fetch categories");
    } catch (error) {
      console.error("Fetch error:", error);
      toast.error("Failed to fetch categories");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.title.trim()) {
      toast.error("Title is required!");
      return;
    }

    try {
      const token = localStorage.getItem("authToken");

      const form = new FormData();
      form.append("title", formData.title);
      form.append("description", formData.description);
      form.append("number", formData.number);
      if (editId) form.append("id", editId);
      const url = editId
        ? "https://backend.soapplants.com/api/v1/industrial-solutions/edit"
        : "https://backend.soapplants.com/api/v1/industrial-solutions/add";

      const response = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`, // No 'Content-Type' → browser sets boundary
        },
        body: form,
      });
      
      const data = await response.json();
      if (response.status === 401)
            {
              toast.error("Session expired, please log in again");
              localStorage.removeItem("authToken");
              navigate('/login');
              return;
            }

      if (data.success) {
        toast.success(data.message);
        setFormData({ title: "", description: "",number:"" });
        setEditId(null);
        setFile(null);
        setPreview("https://cdn-icons-png.flaticon.com/512/10446/10446694.png");
        fetchData();
         if (fileInputRef.current) {
            fileInputRef.current.value = "";
          }
      } else {
        toast.error(data.message || "Failed to save About Us Content");
      }
    } catch (error) {
      console.error("Submit error:", error);
      toast.error("Something went wrong!");
    }
  };


  const handleEdit = (id) => {
    const catToEdit = categories.find((c) => c.id === id);
    if (catToEdit) {
      setFormData({
        id: catToEdit.id,
        title: catToEdit.title,
        description: catToEdit.description || "",
        number: catToEdit.number || "",
      });
      setPreview(catToEdit.image_url || "https://cdn-icons-png.flaticon.com/512/10446/10446694.png");
      setEditId(id);
    }
  };

  const cancelEdit = () => {
    setFormData({ title: "", description: "" });
    setEditId(null);
  };

  const handleDeleteClick = (id) => {
    setItemToDelete(id);
    setDeleteModalShow(true);
  };

  const confirmDelete = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(`https://backend.soapplants.com/api/v1/industrial-solutions/delete`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ id: itemToDelete }),
      });

      const data = await response.json();
      if (data.success) {
        toast.success(data.message);
        setCategories((prev) => prev.filter((cat) => cat.id !== itemToDelete));
      } else {
        toast.error(data.message || "Failed to delete About Us Content");
      }
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Failed to delete About Us Content");
    } finally {
      setDeleteModalShow(false);
      setItemToDelete(null);
    }
  };

  const cancelDelete = () => {
    setDeleteModalShow(false);
    setItemToDelete(null);
  };

  const loadFile = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setPreview(URL.createObjectURL(selectedFile));
      setFile(selectedFile);
    }
  };
  const handlePositionChange = async (id, newPos) => {
    try {
    const token = localStorage.getItem("authToken");
    const form = new FormData();
      form.append("position", newPos);
      if (id) form.append("id", id);
      const response = await fetch(`https://backend.soapplants.com/api/v1/industrial-solutions/editposition`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: form,
      });

      const data = await response.json();
      if (data.success) {
          toast.success(data.message);
          fetchData();
      } else {
        toast.error(data.message || "Failed to Update about us");
      }
    } catch (error) {
      console.error("Update error:", error);
      toast.error("Failed to update about us");
    } finally {
      setDeleteModalShow(false);
      setItemToDelete(null);
    }
  
};

  return (
<div className="role-settings-container">
      <div className="bg-white p-[1vw] role-settings-form-container">
        <div className="text-[20px] font-bold border-b border-gray-300 pb-[2px] text-gray-600">
          <h1>{editId ? "Update Industrial Solutions" : "Add Industrial Solutions"}</h1>
        </div>

        <form className="bg-white pt-1 rounded-lg" onSubmit={handleSubmit}>
          <div className="mb-2">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Title *
            </label>
            <input
              name="title"
              value={formData.title}
              onChange={(e) =>
                setFormData({ ...formData, title: e.target.value })
              }
              type="text"
              placeholder="Enter Title"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"
              required
            />
          </div>

          <div className="mb-2">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Description *
            </label>
            <input
              name="description"
              value={formData.description}
              onChange={(e) =>
                setFormData({ ...formData, description: e.target.value })
              }
              type="text"
              placeholder="Enter Description"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"
              required
            />
          </div>

          <div className="mb-2">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Number *
            </label>
            <input
              name="number"
              value={formData.number}
              onChange={(e) =>
                setFormData({ ...formData, number: e.target.value })
              }
              type="text"
              placeholder="Enter Number"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"
              required
            />
          </div>

          <div className="flex items-center gap-2">
            <button
              type="submit"
              className="bg-blue-500 text-sm hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
            >
              {editId ? "Update" : "Save"}
            </button>
            {editId && (
              <button
                type="button"
                onClick={() => {
                  setFormData({ title: "", description: "",number:"" });
                  setEditId(null);
                  setFile(null);
                  setPreview("https://cdn-icons-png.flaticon.com/512/10446/10446694.png");
                }}
                className="bg-gray-500 text-sm hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
              >
                Cancel
              </button>
            )}
          </div>
        </form>
      </div>
      <ul className="w-full role-settings-display-container">
        <li className="bg-white p-[1vw]">
          <div className="text-[20px] font-bold pb-[10px]">
            <h1>Industrial Solutions List</h1>
          </div>
          <section className="flex flex-col justify-center">
            <div className="h-full">
              <div className="w-full bg-white">
                <div className="overflow-x-auto">
                  <table className="table-auto w-full">
                    <thead className="font-semibold uppercase text-white bg-blue-500">
                      <tr className="grid text-xs grid-cols-6">
                        <th className="px-4 py-2 text-left">#</th>
                        <th className="px-4 py-2 text-left">Title</th>
                        <th className="px-4 py-2 text-left">Number</th>
                        <th className="px-4 py-2 text-left">Position</th>
                        <th className="px-4 py-2 text-left">Description</th>
                        <th className="px-4 py-2 text-center">Action</th>
                      </tr>
                    </thead>
                    <tbody className="text-sm divide-y divide-gray-100">
                      {categories.length > 0 ? (
                        categories.map((cat, index) => (
                          <tr className="grid grid-cols-6" key={cat.id}>
                            <td className="px-4 py-2 flex items-center gap-3"><div>
                                <div className="font-semibold text-gray-800">
                                  {index + 1}
                                </div>
                               
                              </div></td>
                            <td className="py-3 px-4 flex items-center gap-3">
                              <div>
                                <div className="font-semibold text-gray-800">
                                  {cat.title}
                                </div>
                               
                              </div>
                              
                            </td>
                            <td className="py-3 px-4 flex items-center gap-3">
                             
                              <div>
                                <div className="font-semibold text-gray-800">
                                  {cat.number || "—"  }
                                </div>
                               
                              </div>
                            </td>
                            <td className="py-3 px-4 flex items-center gap-3">
                              <div>
                                <div className="font-semibold text-gray-800">
                                  <select
                                    value={cat.position}
                                    onChange={(e) => handlePositionChange(cat.id, e.target.value)}
                                  >
                                    {categories.map((c,index) => (
                                      <option key={c.id} value={index + 1}>
                                        {index + 1}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            </td>
                            
                            <td className="px-4 py-2">{truncateText(cat.description, 100)}</td>
                            <td className="px-4 py-2">
                              <div className="flex gap-2 justify-center items-center">
                                <button
                                  onClick={() => handleEdit(cat.id)}
                                  className="text-blue-500 hover:text-blue-700 text-[20px]"
                                  title="Edit"
                                >
                                  <TbEdit />
                                </button>
                                <button
                                  onClick={() => handleDeleteClick(cat.id)}
                                  className="text-red-500 hover:text-red-700 text-[20px]"
                                  title="Delete"
                                >
                                  <MdDeleteOutline />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={5} className="p-2 text-center">
                            No Industrial Solutions found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>
        </li>
      </ul>

      {deleteModalShow && (
        <DeleteModal
          itemName={
            categories.find((p) => p.id === itemToDelete)?.title ||
            "Title"
          }
          onClose={cancelDelete}
          onDelete={confirmDelete}
        />
      )}
    </div>
  );
};

export default Category;

const truncateText = (text, maxLength = 100) => {
  if (!text) return "—";
  return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
};